<template>
  <v-list flat class="pa-0 link-list">
    <v-list-item
      v-for="(item, index) in items"
      :key="index"
      class="pa-0"
      :to="
        item.linkType !== 'external'
          ? $localePath({ name: toLink(item), query: $route.query })
          : undefined
      "
      :href="item.linkType === 'external' ? item.link : undefined"
      :target="item.target || undefined"
      :class="{ 'mb-2': index < items.length - 1 }"
    >
      {{ item.title }}
    </v-list-item>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex';
import lodash from 'lodash';

export default {
  name: 'LinkList',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      partnerData: 'hrbPartner/partnerData',
      header: 'general/header',
      footerWhite: 'general/footerWhite'
    })
  },
  methods: {
    toLink(item) {
      if (
        this.$route.name &&
        this.$route.name.startsWith('hrb') &&
        !lodash.isEmpty(this.partnerData)
      ) {
        return item.partnerLink;
      }
      if (this.header === 'thematicCounselling') {
        return item.thematicCounsellingLink;
      }
      return item.link;
    }
  }
};
</script>

<style lang="scss" scoped>
.link-list {
  background-color: transparent;
}
</style>
